import React from 'react';
import { navigateTo } from '../../lib/navigation';
import { brand } from '../../mock';
import { useForms } from '../../context/FormsContext';

const HERO_IMG = '/media/harbor.webp';
const PORTRAIT = '/media/kutay-hero.webp';

const badges = [
  '/badges/badge-1.png',
  '/badges/badge-2.png',
  '/badges/badge-3.png',
  '/badges/badge-4.png',
  '/badges/badge-5.png',
];

export default function Hero() {
  const { openForm } = useForms();
  const scrollToAbout = () => {
    navigateTo('/ben-kimim/');
  };

  return (
    <section id="top" style={{ position: 'relative', display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
      {/* Fixed background (no dark overlay — keeps the image tone consistent across the page) */}
      <div style={{ position: 'absolute', inset: 0, backgroundImage: `url(${HERO_IMG})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundAttachment: 'fixed' }} />

      {/* Content */}
      <div className="ckr-site ckr-hero-shell" style={{ position: 'relative', zIndex: 3 }}>
        {/* Wide frosted glass panel that also covers the portrait */}
        <div className="ckr-hero-panel" style={{
          position: 'relative',
          overflow: 'hidden',
          background: 'rgba(16,33,34,0.34)',
          backdropFilter: 'blur(18px) saturate(1.15)',
          WebkitBackdropFilter: 'blur(18px) saturate(1.15)',
          border: '1px solid rgba(246,242,232,0.18)',
        }}>
          {/* Portrait inside the panel (desktop) */}
          <img
            src={PORTRAIT}
            width="1138" height="1382" fetchPriority="high" decoding="async"
            alt={brand.person}
            className="ckr-hero-desktop-portrait"
            style={{ position: 'absolute', right: 'clamp(8px, 1.5vw, 24px)', bottom: 0, height: '102%', maxHeight: 640, width: 'auto', objectFit: 'contain', objectPosition: 'bottom right', filter: 'drop-shadow(0 16px 36px rgba(0,0,0,0.42))', pointerEvents: 'none' }}
          />
          <button
            type="button"
            className="ckr-btn ckr-portrait-about-button ckr-portrait-about-desktop"
            onClick={scrollToAbout}
          >
            önce beni tanıyın
          </button>

          <div className="ckr-hero-content relative z-[2] lg:max-w-[60%]">
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 9, padding: '7px 15px', borderRadius: 999, background: 'rgba(246,242,232,0.1)', border: '1px solid rgba(246,242,232,0.24)', color: '#ece6d8', fontSize: 11.5, fontWeight: 600, letterSpacing: '0.16em', textTransform: 'uppercase' }}>
              REMAX CORNER - Gayrimenkul Danışmanı
            </span>

            <h1 className="ckr-sr-only">Çanakkale Konut Rehberi</h1>
            <h2 className="ckr-hero-title" style={{ color: '#f6f2e8', lineHeight: 1.12, margin: '22px 0 20px', fontWeight: 600 }}>
              Konut kararınızı ilan ezberiyle değil,{' '}
              <span style={{ color: 'var(--ckr-gold-soft)', fontStyle: 'italic', fontWeight: 500 }}>piyasa gerçekleriyle</span> verin.
            </h2>

            <p className="ckr-hero-description" style={{ color: 'rgba(240,234,221,0.9)', lineHeight: 1.6, maxWidth: 540, margin: '0 0 30px' }}>
              Çanakkale'de evinizi satarken, satın alırken veya kiralarken doğru kararı vermeniz için gerçek piyasa değerlerini, bölgesel fırsatları ve alıcı davranışlarını birlikte değerlendiriyoruz.
            </p>

            <div className="ckr-hero-actions">
              <button className="ckr-btn ckr-hero-action ckr-hero-action-black" onClick={() => openForm('satici', 'hero-satici-kiraya-vermek')}>
                Mülkümü Satmak/Kiraya Vermek İstiyorum
              </button>
              <button className="ckr-btn ckr-hero-action ckr-hero-action-buyer"
                onClick={() => openForm('alici', 'hero-alici-kiralayan')}>
                Mülk Satın Almak/Kiralamak İstiyorum
              </button>
              <button className="ckr-btn ckr-hero-action ckr-hero-action-value" onClick={() => openForm('satici', 'hero-deger-tespiti')}>
                Mülkünüz için hemen değer tespiti isteyin!
              </button>
            </div>

            {/* Badges */}
            <div className="ckr-hero-badges">
              {badges.map((b, i) => (
                <span key={i} className="ckr-hero-badge">
                  <img src={b} alt="" />
                </span>
              ))}
            </div>
          </div>
          <div className="ckr-hero-mobile-portrait">
            <img src={PORTRAIT} alt={brand.person} width="1138" height="1382" decoding="async" />
            <button type="button" className="ckr-btn ckr-portrait-about-button ckr-portrait-about-mobile" onClick={scrollToAbout}>önce beni tanıyın</button>
          </div>
        </div>
      </div>
    </section>
  );
}
